import { Route, Routes } from "react-router-dom";
import { Space } from "~/lib/types";
import { Reports } from "~/pages/reports/Reports";

type Props = {
  space: Space;
};

export function ReportingRoutes({ space }: Props) {
  return (
    <Routes>
      <Route index element={<Reports {...{ space }} />} />
    </Routes>
  );
}
